import { AttendanceModel } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { AttendanceAdjustment } from "../entities/attendance-adjustment.entity";
import { AttendanceEntity } from "../entities/attendance.entity";
import { AttendanceAdjustmentDto } from "./attendance-adjustment.dto";

@Injectable()
export class AttendanceAdjustmentAdapter {

    public convertDtoToEntity(employeeId: number, employeeCode: string, employeeName: string, date: string, oldInTime: Date, inTime: Date, oldOutTime: Date, outTime: Date, presentStatus: string, departmentId: number, shiftGroup: string, unitId: number, shift: string, reason: string, remarks: string, appliedDate: Date, createdUser: string
    ) {
        const attnAdjEntity = new AttendanceAdjustment();
        attnAdjEntity.employeeId = employeeId;
        attnAdjEntity.employeeCode = employeeCode;
        attnAdjEntity.employeeName = employeeName;
        attnAdjEntity.date = date;
        attnAdjEntity.oldInTime = oldInTime;
        attnAdjEntity.inTime = inTime;
        attnAdjEntity.oldOutTime = oldOutTime;
        attnAdjEntity.outTime = outTime;
        attnAdjEntity.presentStatus = presentStatus;
        attnAdjEntity.departmentId = departmentId;
        attnAdjEntity.shiftGroup = shiftGroup;
        attnAdjEntity.unitId = unitId;
        attnAdjEntity.shift = shift;
        attnAdjEntity.reason = reason;
        attnAdjEntity.remarks = remarks;
        attnAdjEntity.appliedDate = appliedDate;
        attnAdjEntity.createdUser = createdUser;

        return attnAdjEntity;
    }

    public convertEntityToDto(attnAdjEntity: AttendanceAdjustment): AttendanceAdjustmentDto {
        return new AttendanceAdjustmentDto(attnAdjEntity.attendaceId, attnAdjEntity.employeeId, attnAdjEntity.employeeCode, attnAdjEntity.employeeName, attnAdjEntity.date, attnAdjEntity.oldInTime, attnAdjEntity.inTime, attnAdjEntity.oldOutTime, attnAdjEntity.outTime, attnAdjEntity.presentStatus, attnAdjEntity.departmentId, attnAdjEntity.shiftGroup, attnAdjEntity.unitId, attnAdjEntity.shift, attnAdjEntity.reason, attnAdjEntity.remarks, attnAdjEntity.appliedDate, attnAdjEntity.status);
    }


}